/**
 * Normalize catalog entries (roles, permissions) to comparable labels.
 */
export const toCatalogLabel = (item) => {
  if (item == null) return "";
  if (typeof item === "string") return item.trim();
  return String(
    item.name ||
      item.role ||
      item.roleName ||
      item.permission ||
      item.permissionName ||
      item.code ||
      ""
  ).trim();
};

export const catalogSet = (catalog = []) =>
  new Set(
    (Array.isArray(catalog) ? catalog : []).map(toCatalogLabel).filter(Boolean)
  );

export const catalogLabels = (catalog = []) =>
  Array.from(catalogSet(catalog)).sort((a, b) => a.localeCompare(b));

/** Keep only values that still exist in the live catalog (drop deleted items). */
export const filterByCatalog = (values = [], catalog = []) => {
  const set = catalogSet(catalog);
  return (Array.isArray(values) ? values : [])
    .map((value) => String(value || "").trim())
    .filter((value) => value && set.has(value));
};
